var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9950_328956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.146 4.09999C11.5567 3.62238 10.8778 3.26756 10.1493 3.05644C9.42077 2.84532 8.65735 2.78216 7.90402 2.8707C7.1507 2.95923 6.42273 3.19766 5.76299 3.57194C5.10326 3.94622 4.52512 4.44878 4.06265 5.04999C3.13488 6.26896 2.67512 7.78027 2.76687 9.3094C2.85861 10.8385 3.49579 12.284 4.56265 13.3833L11.4127 20.5333C11.5824 20.7118 11.7866 20.854 12.0129 20.9511C12.2393 21.0482 12.483 21.0983 12.7293 21.0983C12.9756 21.0983 13.2194 21.0482 13.4457 20.9511C13.6721 20.854 13.8763 20.7118 14.046 20.5333L20.896 13.3833C21.9629 12.284 22.6 10.8385 22.6918 9.3094C22.7835 7.78027 22.3238 6.26896 21.396 5.04999C20.9335 4.44878 20.3554 3.94622 19.6957 3.57194C19.0359 3.19766 18.3079 2.95923 17.5546 2.8707C16.8013 2.78216 16.0379 2.84532 15.3093 3.05644C14.5808 3.26756 13.9019 3.62238 13.3127 4.09999C13.1459 4.22973 12.9406 4.30017 12.7293 4.30017C12.518 4.30017 12.3128 4.22973 12.146 4.09999Z",
    fill: "url(#paint0_linear_9950_328956)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9950_328956",
    x1: 7.11266,
    y1: 1.41665,
    x2: 20.5627,
    y2: 19.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9950_328956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.3333,
    fill: "white",
    transform: "translate(2.72949 2.83331)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.9bfea731e65e3ad1f2e61ec25e3f4d0b.svg";
export { ForwardRef as ReactComponent };